<ng-template #utilityBarForm>
  <placement-utility-header [placementData]="placementData" [placementMaintenance]="placementMaintenance"></placement-utility-header>
</ng-template>

<div #container class="tiled-background tw:w-full tw:mx-auto tw:px-4">

  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
    <div class="tw:w-full tw:px-[15px]">
      <h3>Risk Assessment</h3>
    </div>
    <div class="tw:w-full tw:px-[15px]">
      <div class="flex-row tw:justify-start tw:my-1 section-gap">

        <div class="btn-tile" (click)="openRiskAssessmentDialog()">
          <div class="btn-tile__main">
            @if (hasSubmittedRiskAssessment) {
              <i class="las la-check-circle tw:text-[40px] tw:text-primary"></i>
              <div class="btn-tile__text-container tw:text-primary">View Risk Assessment</div>
            } @else {
              <i class="las la-exclamation-circle tw:text-[40px] tw:text-danger"></i>
              <div class="btn-tile__text-container tw:text-danger">Create Risk Assessment</div>
            }
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
    <div class="tw:w-full tw:px-[15px]">
      <h3>Sessions</h3>
    </div>
    <div class="tw:w-full tw:px-[15px]">
      <div class="tw:!justify-start flex-row tw:my-1 section-gap">

        <div class="btn-tile btn-tile--fit-content tile-view-session-icon" (click)="viewSession()">
          <div class="btn-tile__main">
            <div class="btn-tile__icon"></div>
            <div class="btn-tile__text-container">View sessions
              <label class="font-12 font-slategrey tw:hidden tw:sm:block">Open and manage your full session
              calendar</label>
            </div>
            <div class="btn-tile__extra-info-container">
              <div class="tw:flex flex-column">
                <div class="tw:flex tw:mb-1 tw:w-full">
                  <span class="badge badge-pill badge-info"> {{
                  placementMaintenance.sessionSummaryInformation.savedSessions }} </span>
                  <label class="font-12 tw:mb-0 tw:ml-2 tw:pb-0">Saved</label>
                </div>
                <div class="tw:flex tw:mb-1 tw:w-full">
                  <span class="badge badge-pill badge-purple"> {{
                  placementMaintenance.sessionSummaryInformation.submittedSessions }} </span>
                  <label class="font-12 tw:mb-0 tw:ml-2 tw:pb-0">Submitted</label>
                </div>
                <div class="tw:flex tw:mb-1 tw:w-full">
                  <span class="badge badge-pill badge-success"> {{
                  placementMaintenance.sessionSummaryInformation.approvedSessions }} </span>
                  <label class="font-12 tw:mb-0 tw:ml-2 tw:pb-0">Approved</label>
                </div>
                <div class="tw:flex tw:mb-1 tw:w-full">
                  <span class="badge badge-pill badge-danger"> {{
                  placementMaintenance.sessionSummaryInformation.rejectedSessions }} </span>
                  <label class="font-12 tw:mb-0 tw:ml-2 tw:pb-0">Rejected</label>
                </div>
                <div class="tw:flex tw:w-full">
                  <span class="badge badge-pill badge-secondary"> {{
                  placementMaintenance.sessionSummaryInformation.cancelledSessions }} </span>
                  <label class="font-12 tw:mb-0 tw:ml-2 tw:pb-0">Cancelled</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
    <div class="tw:w-full tw:px-[15px]">
      <h3>Learners</h3>
    </div>
    @if (placementData.isGroup) {
    <div class="tw:w-full tw:px-[15px]">
      <tutor-report-group [includeContainerGutter]="false" [clientId]="clientId"></tutor-report-group>
    </div>
    }
    @if (!placementData.isGroup) {
    <div class="tw:w-full tw:px-[15px]">
      <tutor-report-group [includeContainerGutter]="false" [clientId]="clientId"></tutor-report-group>
    </div>
    }
  </div>

  <!--<div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
    <div class="tw:w-full tw:px-[15px]">
      <h3>Learning sections</h3>
    </div>

    <div class="tw:w-full tw:px-[15px] section-gap">

      <div class="btn-tile  tile-plus-icon">
        <div class="btn-tile__main" (click)="addGroupLearningSection()">
          <div class="btn-tile__icon"></div>
          <div class="btn-tile__text-container">Add group learning section</div>
        </div>
      </div>

    </div>
  </div>-->

  @if (showLaunchOnlineRoomButton) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
      <div class="tw:w-full tw:px-[15px]">
        <h3>Online</h3>
      </div>
      <div class="tw:w-full tw:px-[15px] section-gap">
        <div class="btn-tile  tile-online-room-icon">
          <div class="btn-tile__main" (click)="launchOnlineLesson()">
            <div class="btn-tile__icon"></div>
            <div class="btn-tile__text-container">Launch online room</div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (showOfferOnlineClassroom) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
      <div class="tw:w-full tw:px-[15px]" id="offerOnlineClassroom">
        <h3>Online Tuition</h3>
        <p class="font-14 tw:mb-3">This booking is in person. If a session is delivered online, set up the Digital Classroom
          for this booking to run it and invite the learner. The booking in Orbit is not changed.</p>
        <button mat-button class="btn btn-primary tw:my-1" type="button" id="offerOnlineClassroomButton"
          [disabled]="offeringOnlineClassroom" (click)="offerOnlineClassroom()">Set up online classroom</button>
      </div>
    </div>
  }

  @if (showMissingRoomWarning) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
      <div class="tw:w-full tw:px-[15px]">
        <div class="alert alert-warning tw:mb-0" id="missingRoomWarning">
          <strong>Online booking</strong> &mdash; the Digital Classroom for this booking has not been
          set up yet. Classrooms are created automatically within a few minutes; refresh shortly, and if
          this persists contact support.
        </div>
      </div>
    </div>
  }

  @if (showLaunchDigitalClassroom) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
      <div class="tw:w-full tw:px-[15px]">
        <h3>Online Tuition</h3>
        <!-- When the session is, stated before the control that depends on it — reading the button
             first and its precondition afterwards is the wrong way round. -->
        @if (hasLaunchDigitalClassroomPermission && launchWindowSessionLabel) {
          <p class="font-14 tw:mb-3" id="launchWindowSession">{{launchWindowSessionLabel}}</p>
        }
      </div>
      <div class="tw:w-full tw:px-[15px] section-gap">
        @if (hasLaunchDigitalClassroomPermission && hasSession && launchWindowOpen) {
          <div class="btn-tile tile-digital-classroom-icon tw:mb-4"
            >
            <div class="btn-tile__main" (click)="launchDigitalClassroom(false)">
              <div class="btn-tile__icon"></div>
              <div class="btn-tile__text-container">Launch online classroom</div>
            </div>
          </div>
        }
        <!-- Outside the 90-minute window the tile is visibly unavailable and says WHEN it opens,
             rather than looking usable and refusing the click. Prepare Room below stays available,
             which is what the old error text told people to do after they had already been refused. -->
        @if (hasLaunchDigitalClassroomPermission && hasSession && !launchWindowOpen) {
          <div class="btn-tile btn-tile_not-allowed tile-digital-classroom-icon tw:mb-4"
            >
            <div class="btn-tile__main">
              <div class="btn-tile__icon"></div>
              <div class="btn-tile__text-container">Launch online classroom</div>
            </div>
          </div>
          <p class="font-14 tw:mt-1 tw:mb-4" id="launchWindowHint">
            {{launchWindowHint}}
            <br />Use <strong>Prepare online classroom</strong> below to set the room up beforehand.
          </p>
        }
        @if (hasLaunchDigitalClassroomPermission && !hasSession) {
          <div class="btn-tile btn-tile_not-allowed tile-digital-classroom-icon tw:mb-4"
            >
            <div class="btn-tile__main">
              <div class="btn-tile__icon"></div>
              <div class="btn-tile__text-container">Launch online classroom</div>
            </div>
          </div>
        }
      </div>
      <div class="tw:w-full tw:px-[15px] section-gap">
        @if (hasOnlineSessionSetupPermission) {
          <div class="btn-tile tile-digital-classroom-prep-icon tw:mb-4"
            >
            <div class="btn-tile__main" (click)="launchPrepOnlineRoom()">
              <div class="btn-tile__icon"></div>
              <div class="btn-tile__text-container">Prepare online classroom</div>
            </div>
          </div>
        }
      </div>
      <div class="tw:w-full tw:px-[15px] section-gap">
        @if (hasOnlineOverviewClientPermission || hasOnlineOverviewAdminPermission) {
          <div class="btn-tile tile-digital-classroom-overview-icon tw:mb-4"
            >
            <div class="btn-tile__main" (click)="launchOnlineOverview()">
              <div class="btn-tile__icon"></div>
              <div class="btn-tile__text-container">Launch Online Overview</div>
            </div>
          </div>
        }
      </div>
      <div class="tw:w-full tw:px-[15px] section-gap">
        <div class="btn-tile tile-video-library-icon tw:mb-4">
          <div class="btn-tile__main" (click)="launchVideoLibrary()">
            <div class="btn-tile__icon"></div>
            <div class="btn-tile__text-container">Launch video library</div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (studentFeedbackPermission) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-6">
      <div class="tw:w-full tw:px-[15px]">
        <h3>Feedback</h3>
      </div>
      <div class="tw:flex-1 tw:px-[15px] section-gap">
        <div class="btn-tile  tile-pupil-voice-icon tw:w-full"
          [ngClass]="{'btn-tile-no-scale': voiceExpanded, 'section-expanded': voiceExpanded}">
          <div class="btn-tile__main" (click)="voiceExpanded = !voiceExpanded">
            <div class="btn-tile__icon"></div>
            <div class="btn-tile__text-container">Learner Voice</div>
            <div class="btn-tile__extra-info-container small" [ngClass]="{'no-left-border': voiceExpanded}">
              @if (voiceExpanded) {
                <span class="chevron-close-icon tw:float-right"></span>
              }
              @if (!voiceExpanded) {
                <span class="chevron-open-icon tw:float-right"></span>
              }
            </div>
          </div>
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px] expandable-section-content" [ngClass]="{'content-visible': voiceExpanded}">
            @for (item of students; track item; let i = $index) {
              <div class="tw:w-full tw:px-[15px] tw:mt-4 tw:mb-2">
                <div class="flex-row">
                  <div class="flex-column tw:justify-center tw:content-center"
                    style="max-width: 250px;">
                    <label>{{item.studentFirstName}} {{item.studentLastName}}</label>
                  </div>
                  <div class="flex-column">
                    <div class="div-flex-buttons tw:justify-start tw:items-start">
                      <button mat-button class="btn btn-primary tw:my-1 tw:mr-2"
                        (click)="sendStudentFeedbackLink(item)">Generate
                      feedback link</button>
                      <button mat-button class="btn btn-primary tw:my-1 tw:mr-2"
                      (click)="enterStudentFeedbackManually(item)">Enter feedback manually</button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

</div>
